import { render, staticRenderFns } from "./DetailGamesResult.vue?vue&type=template&id=aba2a38c&scoped=true&"
import script from "./DetailGamesResult.vue?vue&type=script&lang=js&"
export * from "./DetailGamesResult.vue?vue&type=script&lang=js&"
import style0 from "./DetailGamesResult.vue?vue&type=style&index=0&id=aba2a38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba2a38c",
  null
  
)

export default component.exports